import React from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { cores } from '../../theme';
import {
    Typography, Container, Box, List, Paper, IconButton, Avatar, ListItemButton, ListItemText, ListItemAvatar, Fade, useTheme
} from '@mui/material';
import {
    ArrowBack, School, Group, ManageAccounts, Biotech, PlaylistAddCheck, Grading
} from '@mui/icons-material';

const itensGerenciamento = [
    {
        titulo: 'Módulos',
        descricao: 'Crie e edite os módulos do curso.',
        link: '/gerenciar-modulos',
        icone: <School />
    },
    {
        titulo: 'Turmas',
        descricao: 'Crie turmas e adicione participantes.',
        link: '/gerenciar-turmas',
        icone: <Group />
    },
    {
        titulo: 'Professores',
        descricao: 'Cadastre e administre os professores.',
        link: '/gerenciar-professores',
        icone: <ManageAccounts />
    },
    {
        titulo: 'Casos Clínicos',
        descricao: 'Crie e edite os casos de estudo.',
        link: '/gerenciar-casos',
        icone: <Biotech />
    },
    {
        titulo: 'Critérios',
        descricao: 'Gerencie a biblioteca de critérios.',
        link: '/gerenciar-criterios',
        icone: <PlaylistAddCheck />
    },
    {
        titulo: 'Opções de Resposta',
        descricao: 'Defina as escalas de nota da plataforma.',
        link: '/gerenciar-opcoes-resposta',
        icone: <Grading />
    }
];

const GerenciamentoHubPagina = () => {
    const navegar = useNavigate();
    const theme = useTheme();

    return (
        <Container maxWidth="lg" sx={{ py: { xs: 3, sm: 4 } }}>
            <Paper
                sx={{
                    p: { xs: 2, sm: 4 },
                    borderRadius: 3,
                    boxShadow: cores.sombras.medio,
                }}
            >
                {/* Header com título */}
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        mb: 4,
                        p: { xs: 2, sm: 3 },
                        borderRadius: 2,
                        background: cores.gradientes.primario,
                        color: 'white'
                    }}
                >
                    <IconButton
                        onClick={() => navegar('/')}
                        sx={{
                            mr: 2,
                            color: 'white',
                            bgcolor: 'rgba(255,255,255,0.2)',
                            '&:hover': {
                                bgcolor: 'rgba(255,255,255,0.3)',
                            }
                        }}
                    >
                        <ArrowBack />
                    </IconButton>
                    <Box sx={{ flex: 1 }}>
                        <Typography
                            variant="h4"
                            component="h1"
                            sx={{
                                fontWeight: 700,
                                fontSize: { xs: '1.5rem', sm: '1.75rem', md: '2rem' },
                                lineHeight: 1.2
                            }}
                        >
                            Painel de Gerenciamento
                        </Typography>
                        <Typography
                            variant="body1"
                            sx={{
                                opacity: 0.9,
                                fontSize: { xs: '0.9rem', sm: '1rem' }
                            }}
                        >
                            Selecione uma área para gerenciar
                        </Typography>
                    </Box>
                </Box>

                {/* Título da seção */}
                <Box sx={{ mb: 3, px: { xs: 1, sm: 0 } }}>
                    <Typography
                        variant="h5"
                        component="h2"
                        sx={{
                            fontWeight: 700,
                            color: cores.primaria.principal,
                            mb: 1,
                            fontSize: { xs: '1.25rem', sm: '1.5rem' }
                        }}
                    >
                        Áreas Administrativas
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{
                            color: cores.cinza.escuro,
                            fontSize: { xs: '0.875rem', sm: '1rem' }
                        }}
                    >
                        Acesse as ferramentas de administração do sistema
                    </Typography>
                </Box>

                {/* Lista de itens de gerenciamento */}
                <List sx={{ width: '100%' }}>
                    {itensGerenciamento.map((item, indice) => (
                        <Fade in={true} timeout={300 + (indice * 100)} key={item.titulo}>
                            <ListItemButton
                                component={RouterLink}
                                to={item.link}
                                sx={{
                                    mb: 2,
                                    borderRadius: 2,
                                    background: '#f8f9fa',
                                    boxShadow: cores.sombras.suave,
                                    transition: 'all 0.2s ease',
                                    '&:hover': {
                                        transform: 'translateY(-2px)',
                                        boxShadow: cores.sombras.medio,
                                        background: '#f1f3f5',
                                    },
                                    p: 2,
                                }}
                            >
                                <ListItemAvatar>
                                    <Avatar sx={{ background: cores.gradientes.primario }}>
                                        {item.icone}
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                    primary={
                                        <Typography variant="h6" sx={{ fontWeight: 600, color: cores.primaria.principal }}>
                                            {item.titulo}
                                        </Typography>
                                    }
                                    secondary={
                                        <Typography variant="body2" sx={{ color: cores.cinza.medio }}>
                                            {item.descricao}
                                        </Typography>
                                    }
                                />
                            </ListItemButton>
                        </Fade>
                    ))}
                </List>
            </Paper>
        </Container>
    );
};

export default GerenciamentoHubPagina;